import { Provider } from '@angular/core';

import { Capacitor } from '@capacitor/core';

import { GeolocationService } from '../Domain/geolocation.service';
import { CapacitorGeolocationService } from '../Infrastructure/Adapter/Capacitor/capacitor-geolocation.service';
import { WebGeolocationService } from '../Infrastructure/Adapter/WebNavigator/web-geolocation.service';

/**
 * Factory function to create the appropriate GeolocationService based on the platform
 */
export function geolocationServiceFactory() {
    return Capacitor.isNativePlatform() ? new CapacitorGeolocationService() : new WebGeolocationService();
}

/**
 * Function to provide the GeolocationService as an array of providers
 */
export const provideGeoLocationService = (): Provider[] => {
    return [
        {
            provide: GeolocationService,
            useFactory: geolocationServiceFactory
        }
    ];
};
